<template>
  <v-card class="px-1">
    <v-tabs v-model="tab" grow>
      <v-tab>
        Přidružení poskytovatelé
      </v-tab>
      <v-tab>
        Volní poskytovatelé
      </v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <template>
          <v-card>
            <v-btn
              class="mx-4 my-4"
              small
              color="red"
              outlined
              style="color: red"
              @click="removeProvidersFromPartner"
              :disabled="selectedProvidersTableData.length === 0"
              >ODEBRAT POSKYTOVATELE</v-btn
            >
            <v-data-table
              class="yzz-table"
              dense
              :headers="headers"
              :items="items"
              :server-items-length="itemsLength"
              :options.sync="options"
              :footer-props="footerProps"
              show-select
              v-model="selectedProvidersTableData"
              item-key="_id"
            >
            </v-data-table>
          </v-card>
        </template>
      </v-tab-item>
      <v-tab-item>
        <template>
          <v-card>
            <v-btn
              class="mx-4 my-4"
              small
              color="green"
              outlined
              style="color: green"
              @click="addProvidersToPartner"
              >PŘIDAT POSKYTOVATELE</v-btn
            >
            <v-data-table
              class="yzz-table"
              dense
              :headers="headers"
              :items="items2"
              :server-items-length="items2Length"
              :options.sync="options2"
              :footer-props="footerProps"
              show-select
              v-model="selectedProvidersWithoutPartner"
              item-key="_id"
            >
            </v-data-table>
          </v-card>
        </template>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import UserWarningsTable from "@/components/app/users/details/UserWarningsTable";
import UserSalariesTable from "@/components/app/users/details/UserSalariesTable";
import UserTransactionsTable from "@/components/app/users/details/UserTransactionsTable";
import UserPaymentsTable from "@/components/app/users/details/UserPaymentsTable";
import UserReviewsTable from "@/components/app/users/details/UserReviewsTable";
import { generateRequestParams } from "@/helper/global-helper";

export default {
  props: {
    userId: {},
    provider: false,
  },
  name: "PartnerCardDetails",
  components: {
    UserWarningsTable,
    UserSalariesTable,
    UserTransactionsTable,
    UserPaymentsTable,
    UserReviewsTable,
  },
  data() {
    return {
      tab: 0,
      options: {
        itemsPerPage: 15,
      },
      options2: {
        itemsPerPage: 15,
        page: 1,
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50],
      },
      selectedUser: [],
      headers: [
        { text: "ID", value: "_id", sortable: false, key: "_id", width: "20%" },
        { text: "Jméno", value: "businessName", sortable: false },
      ],
      providersTable: null,
      providersWithoutPartnerTable: null,
      selectedProvidersTableData: [],
      selectedProvidersWithoutPartner: [],
    };
  },
  mounted() {
    this.getProvidersWithoutPartner();
    this.getUserProviders();
  },
  computed: {
    itemsLength() {
      if (!this.providersTable) return 0;
      return this.providersTable.length;
    },
    items() {
      if (!this.providersTable) return [];
      return this.providersTable;
    },
    items2Length() {
      if (!this.providersWithoutPartnerTable) return 0;
      return this.providersWithoutPartnerTable.total;
    },
    items2() {
      if (!this.providersWithoutPartnerTable) return [];
      return this.providersWithoutPartnerTable.data;
    },
  },
  methods: {
    getUserProviders() {
      this.axios
        .get("/v1/partners/" + this.userId)
        .then(({ data }) => {
          this.providersTable = data.providers;
        })
        .catch(() => this.$router.go(-1));
    },
    getProvidersWithoutPartner() {
      let params = generateRequestParams(
        this.options2.itemsPerPage * (this.options2.page - 1),
        this.options2.itemsPerPage,
        null,
        "asc"
      );
      params.append("filter[has_partner]", false);
      params.append("filter[is_provider]", true);
      this.axios
        .get("v1/users", {
          params,
        })
        .then(({ data }) => {
          this.providersWithoutPartnerTable = data;
        });
    },
    addProvidersToPartner() {
      this.axios
        .put(`/v1/partners/${this.userId}/add-providers`, {
          providerIds: this.selectedProvidersWithoutPartner.map((p) => p._id),
        })
        .then((data) => {
          this.providersTable = data.data.providers;
          this.getProvidersWithoutPartner();
          this.$store.commit("addAlert", {
            type: "success",
            message: "Úspěšně",
          });
        });
    },
    removeProvidersFromPartner() {
      let selectedProvidersTableDataIds = this.selectedProvidersTableData.map(
        (selectedData) => selectedData._id
      );

      this.axios
        .put(`/v1/partners/${this.userId}/remove-providers`, {
          providerIds: selectedProvidersTableDataIds,
        })
        .then((data) => {
          this.getProvidersWithoutPartner();
          this.providersTable = this.providersTable.filter(
            (item) => !selectedProvidersTableDataIds.includes(item._id)
          );
          this.$store.commit("addAlert", {
            type: "success",
            message: "Úspěšně",
          });
        });
    },
  },
  watch: {
    options: {
      handler() {
        this.getUserProviders();
      },
      deep: true,
    },
    options2: {
      handler() {
        this.getProvidersWithoutPartner();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
